import BaseEntity from "@/core/misc/BaseEntity";
import StickerType from "@/domains/Stickers/StickerType"

class Sticker extends BaseEntity {

	public stickerType: StickerType | null;

	static fromServer(data: any, sticker: Sticker = new Sticker()) {
		super.fromServer(data, sticker);

		sticker.stickerType = data?.stickerType ? StickerType.fromServer(data?.stickerType, new StickerType()) : null;

		return sticker;
	}

}

export default Sticker;
